// Member QR card file names (for the download), keyed by bio slug. Cards are in assets/qr/<slug>.jpg.
const qrCardNames = {
  alexanderk: 'MR. ALEXANDER KUSHNAREV',
  amornphant: 'MS. AMORNPHAN THAMMAPRUKSA',
  amornphitk: 'MS.AMORNPHIT KITTIPODJANASIT',
  amornpont: 'MR.AMORNPON',
  anandat: 'MR. ANANDA TATARINOV',
  anantayak: 'MS. ANANTAYA KULTANAKORN',
  andreif: 'MR. ANDREI FEDOROV',
  andrewl: 'MR. ANDREW LINDQVIST',
  angieo: 'MS. ANGELICA JOSELINE OLSSON',
  aniwatl: 'MR. ANIWAT LEKPASOM',
  annar: 'MS.ANNA RUSSAMEEWONG',
  anuchaw: 'MR.ANUCHA WIBOONWATTANAKIT',
  anukulc: 'MR. ANUKUL CHAMROON',
  archirawishp: 'MR. ARCHIRAWISH PAKCHOTIPONG',
  asdawutc: 'LT. ASDAWUT CHODSAPTHAWEE',
  athichonmf: 'MR. ATHICHONM FUANGKAEW',
  augusts: 'MR. AUGUST SELKE',
  aurathail: 'MS.AURATHAI LOYMAKE ',
  autp: 'CDR. AUT PANGPASSA',
  barbarab: 'MS. BARBARA BARZARKINA',
  benjaminb: 'MR. BENJAMIN BROWN',
  billyz: 'MR.BILLY ZAENGLEIN',
  borwonr: 'MR. BORWON ROCHANAPON',
  bowwonlukc: 'MS. BOWWONLUK CHAMNANPOOD',
  busayarinr: 'MS.BUSAYARIN RUENRUAISAP',
  carinad: 'MS. CARINA DEKE',
  carolync: 'MS. CAROLYN COWAN',
  chaiwatt: 'MR. CHAIWAT THIRAPANTU',
  chaiyutv: 'MAJ.GEN. CHAIYUT VAJIRAVARABHAKTI',
  chakchaia: '1ST LT. CHAKCHAI ANUPONGPAT',
  chanchita: 'MR.CHANCHIT',
  chanmethap: 'MR. CHANMETHA PERMPUL',
  chatchawane: 'MR. CHATCHAWAN EGAWARIN',
  chayanind: 'MS. CHAYANIN DUANGPROM',
  chayaphatk: 'MS. CHAYAPHAT KLAYKLUNG',
  cheiax: 'MR. CHAY XAVIER',
  choochaic: 'MR.CHOOCHAI CHINNAWONG',
  choosakp: 'MR. CHOOSAK PHUMUEANG',
  chucheeps: 'MR.CHUCHEEP SOONTARANONT',
  crystalmd: 'MS. CRYSTAL MARIE DABI',
  danaiy: 'GEN. DANAI YUWABOON',
  darann: 'MR.DARAN NANTAPONG',
  ekasitw: 'MR. EKASIT WIPULANUSAT',
  ericc: 'MR. ERIC CORNILE',
  eugenea: 'MR. EUGENE ANG',
  fuengwichm: 'MR.FUENGWICH MANEEKARN ',
  issariyapar: 'MS. ISSARIYAPA ROOPSUWANNAKUL',
  jacquesp: 'MR. JACQUES DU PLESSIS',
  jaiklal: 'MR. JAIKLA LORGUNPAI',
  jamesrh: 'MR. JAMES RICKY HEBBLETHWAITE',
  janicej: 'MS. JANICE JAMES',
  janyaporns: 'MS.JANYAPORN SAINGAM',
  jarunnops: 'MR. JARUNNOP SIRIVORAPAIBOON',
  jaruwann: 'MS. JARUWAN NUMPHA',
  jasona: 'MR. HUA YIK ANG',
  jeerawita: 'MR. JEERAWIT AREERAS',
  jiaminb: 'MS. JIAMIN BI',
  jirananu: 'MS. JIRANAN UDOMKITWANIT',
  johnh: 'MR. JOHN HU',
  jonathanc: 'MR.JONATHAN CAEL',
  kanina: 'MR. KANIN AMPAIPAN',
  kank: 'MR. KAN KAIWANNON',
  kannikad: 'MS. KANNIKA DEPPETTIKORN',
  kanokphonc: 'MS.KANOKPHON CHAIYAWONG',
  kansinees: 'MS. KANSINEE SAIMONTREE',
  kanyaphatp: 'MS. KANYAPHAT PRIYACHANASAKUL',
  karlr: 'MR.KARL RASMIDATTA',
  karnts: 'MR. KARNT SRISUWAN ',
  ketkanoka: 'MS.KETKANOK AINSUN',
  kittichoten: 'MR. KITTICHOTE NAIYACHIT',
  kittipatw: 'MR. KITTIPAT WIRIYA',
  kittisaks: 'MAJ. KITTISAK SIRIPARP',
  kosinm: 'MR.KOSIN MUNGCHAROEN',
  kridsadad: 'MR.KRIDSADA DEEROADJANADEJ',
  krittitatw: 'MR. KRITTITAT WANSU',
  linh: 'MR. LIN YAN HTYT',
  liudmilam: 'MS. LIUDMILA MARYUTINA',
  lolas: 'MS.LOLA SCHOENLAUB ',
  loonweewatt: 'MR. LOONWEEWAT TAN',
  lulladaa: 'MS. LULLADA ANANTAPAN',
  manussaporne: 'MS. MANUSSAPORN EKVISIT',
  marceld: 'MR. MARCEL DEKE',
  marcop: 'MR. MARCO PENNA',
  marks: 'MR.MARK',
  marvins: 'MR.MARVIN',
  matsakaj: 'MR. MATSAKA JANSAWANG',
  matthewp: 'MR.MATTHEW PEYTON',
  maytapornc: 'MS. MAYTAPORN CHUPINIJSAK',
  metapornc: 'MS. METAPORN CHIM-IM',
  michion: 'MR. MICHIO NISHINARITA',
  mitts: 'MR.MITT',
  nadaphatn: 'MS.NADAPHAT NGANVONGPANIT',
  namont: 'MS. NAMON THATTIYAPHONG',
  nannaphatp: 'MS. NANNAPHAT PRIYACHANASAKUL',
  napasanunv: 'MS. NAPASANUN VONGVIVAT',
  naphatradaq: 'MS. NAPHATRADA QIN',
  naphatsorny: 'MS. NAPHATSORN YOTSIRIPORNCHAI',
  napolp: 'MR. NAPOL PITAYAPAT',
  naprachm: 'MR.NAPRACH MONUM',
  naras: 'MR. NARA SINGHSATHITSUK',
  narat: 'MS. NARA TAKIGUCHI',
  narns: 'MR. NARN SUDRAK',
  narongritn: 'MR.NARONGRIT NARTSUNGNOEN',
  naruekarink: 'MR. NARUEKARIN KHEMARUT',
  narumolt: 'MS. NARUMOL THAMMAPRUKSA',
  naruporns: 'MR.NARUPORN',
  nataphatn: 'MR.NATAPHAT NGANVONGPANIT',
  natchanonk: 'MR. NATCHANON KRAIRAVEE',
  natdanaid: 'MR. NATDANAI DOUNGRATSAMEE',
  natnateep: 'MR. NATNATEE PEEPANICH',
  natsawittau: 'MS. NATSAWITTA UNGPRAPAKORN',
  nattasuth: 'MR. NATTASUT HATTAGRUM',
  nattawuta: 'MR. NATTAWUT ASSARASRI',
  natthaphati: 'MR. NATTHAPHAT INGSAKULSOMBOON',
  natthapony: 'MR. NATTHAPON YATAN',
  nechayas: 'MS.NECHAYA SITTHIKORNWANICH',
  new: 'MR. NE WILAIPAN',
  nichaj: 'MS. NICHA JAMJUN',
  niksak: 'MR. NIKSA KIATTHANAPIBOON',
  niratb: 'MR. NIRAT BOONYASAWET',
  nirunc: 'LT. NIRUN CHANTAWARO',
  nitchakarnt: 'CPO1. NITCHAKARN THAWORNKAN',
  nithiss: 'MR. NITHIS SIWATHEWINTRA',
  niwats: 'MR.NIWAT SEESANGNGAM',
  nonthapornk: 'MS.NONTHAPORN KETKHAO',
  nueas: 'MS. NUEA SUDRAK',
  nutchan: 'MS. NUTCHA NAKAEW ',
  orawanp: 'MS. ORAWAN PONGPRUEKSAPATTANA',
  ornranatp: 'MS.ORNRANAT PINTASIRI',
  pakawadn: 'MR.PAKAWAD',
  panupats: 'LT. PANUPAT SANSOOK',
  panyaphatk: 'MR. PANYAPHAT KONGSEANG',
  panyasuphak: 'MS. PANYASUPHA KHEMARUT',
  paramir: 'MR.PARAMI  RINGKRATHOK',
  paricharts: 'MS.PARICHART',
  parinb: 'MR. PARIN BOONYADETWONG',
  pasuthan: 'MR. PASUTHA NAKGUETHONG',
  patanins: 'MR.PATANIN SIRIPRU',
  patawank: 'MS. PATAWAN KANPLIEN',
  pathikornk: 'MR.PATHIKORN KAJONRUNGSILP',
  pats: 'MR. PAT SUTHAPUNNAKUL',
  pattapongc: 'PO. PATTAPONG CHOKPRADITSUK',
  pattarananp: 'MS. PATTARANAN PHUMUEANG',
  pattarapony: 'MR. PATTARAPON YOUNGHAIPON',
  patwareek: 'MS. PATWAREE KITIWATCHARACHAROEN',
  pawanratc: 'MS. PAWANRAT CHUPINIJSAK',
  pawatchakornh: 'MR. PAWATCHAKORN HASUNHA',
  pawornwichw: 'MASTER PAWORNWICH WONGPENG',
  pemikar: 'MS. PEMIKA RATTANA',
  phanuphongk: 'MR. PHANUPHONG KHETKRATHOK',
  phasinl: 'MR.PHASIN LEKSOMBUN ',
  phattarakritl: 'MR. PHATTARAKRIT LAPANALARPLOY',
  phimmadak: 'MS. PHIMMADA KHUNKHAMPRA',
  phuphumj: 'MR. PHUPHUM JIRACHANKIAT',
  phurint: 'MR.PHURIN THEERAWECHKUL',
  phusins: 'MR. PHUSIN SIWATHEWINTRA',
  pichamonc: 'MS. PICHAMON CHAIWONG',
  pimphisal: 'MS.PIMPHISA LEKSOMBUN ',
  pimpidat: 'MS.PIMPIDA THEERAWECHKUL',
  pipatphongw: 'MR.PIPATPHONG WONGYAI',
  piroontipl: 'MS. PIROONTIP LAKKHANAWIROT',
  pisutk: 'MR. PISUT KRIANGBURAPA',
  pittayac: 'MR. PITTAYA CHAMNANPOOD',
  piyabutrl: 'MR. PIYABUTR LORGRAILERS',
  piyachutc: 'MRS. PIYACHUT CHANTARAMUNGKORN',
  piyanats: 'MR. PIYANAT SUPATTHANAKORNKIT',
  pobkhunt: 'MR.POBKHUN TRAI-UKOT',
  pongnarts: 'MR. PONGNART SAPSOMPONG',
  pongworakornp: 'MR. PONGWORAKORN PAOJEEN',
  poonkanuto: 'MS. POONKANUT OMARAK',
  porametn: 'MR. PORAMET NGOENAINTA',
  pordeer: 'MS. PORDEE RATTANARAK',
  praewpuns: 'PO. PRAEWPUN SUWANNAKOT',
  praphatpongy: 'MR. PRAPHATPHONG YOODEE',
  pummad: 'MR. PUMMA DOUNGRUTANA',
  punnapatw: 'MASTER PUNNAPAT WORACHAYANGKUL',
  punnawatk: 'MR. PUNNAWAT KRAIRAVEE',
  purip: 'MR.PURI PUENGPIPATTRAKUL',
  puttd: 'MR. PUTT DUANGTOON',
  rakchanokc: 'MS.RAKCHANOK CHAYUTKUL',
  rakhunt: 'MS. RAKHUN TRAI-UKOT',
  ratarmontrees: 'MR. RATARMONTREE SUKHOT',
  ratchadapornn: 'MS. RATCHADAPORN NONNUSAT',
  ratchadaporns: 'MS.RATCHADAPORN SIRIWONG',
  ratchaninp: 'MS. RATCHANIN PEEPANICH',
  ratcharatp: 'MS. RATCHARAT PANGPASSA',
  rattanas: 'MS.RATTANA SUDSOM',
  rattapongp: 'LT. RATTAPONG PONGSUWAN ',
  riradav: 'PO. RIRADA VANITWORACHOT',
  ronbanchoba: 'MR. RONBANCHOB APIRATIKUL',
  salineeb: 'MS.SALINEE BOWONRATTANAPAT',
  sanphets: 'CPO1.SANPHET SUKPRATHUEANG',
  santis: 'MR. SANTI SIRISAK',
  sathawathak: 'MR. SATHAWATHA KLAYKLUNG',
  sengdaviengd: 'MS. SENGDAVIENG DOUANGPANYA',
  shinehl: 'MR. SHINE HTET LINN',
  shintarok: 'MR. SHINTARO KON',
  shosont: 'MR. SHOSON THATAWAKORN',
  sirapopes: 'MR. SIRAPOPE SOONTORNNUCH',
  sirawichu: 'MR. SIRAWICH UDOMKANA',
  siriphornm: 'MS.SIRIPHORN MANOKAEW ',
  siwathornr: 'MR. SIWATHORN RATICHOTKAWIN',
  sombatt: 'MR.SOMBAT TAPANYA ',
  somchaic: 'MR. SOMCHAI CHAIYACHETDUMRONGKUL',
  sreytiah: 'MS. SREYTIA HEBBLETHWAITE',
  stefank: 'MR. STEFAN KOKOSZA',
  sukunyak: 'MS.SUKUNYA KAEWSANGJAI ',
  sunchuym: 'MR.SUNCHUY MOSIKARAT',
  sunyal: 'CPO1. SUNYA LAEID',
  supachais: 'CPO1. SUPACHAI SITTIRUK',
  supapimpisap: 'MS. SUPAPIMPISA PISETSILP',
  suphatchayab: 'MS. SUPHATCHAYA BOONYASUKANON',
  suphodh: 'CPO. SUPHOD HARASAN',
  surachett: 'MR.SURACHET THAREEPHUT',
  surateer: 'MR. SURATHEE RUNGTHINPHUTTHICHAI',
  surink: 'MR.SURIN KAMMANEE',
  suteed: 'COL. SUTEE DUANGTOON',
  tanapolp: 'RADM. TANAPOL PITAYAPAT',
  tarah: 'MS. TARA HEBBLETHWAITE',
  tarnnamthips: 'MS.TARNNAMTHIP SIRIWONG',
  techathatw: 'MR. TECHATHAT WATTANAPHORN',
  teeraratb: 'MR.TEERARAT BORIPANTAKOON',
  teerayutp: 'CAPT. TEERAYUT PAKDEEPAK',
  thakhunk: 'MR.NATTAPONG KAEWISARAPRAN',
  thammachartt: 'MR. THAMMACHART THONGWATTANA',
  thanachotec: 'MR.THANACHOTE CHEEVAPITAKPHOL',
  thanaip: 'COL. THANAI PERMPUL',
  thanasons: 'MS. THANASON SAMRANRUEN',
  thantnyim: 'MR.THANTNYI MINHTUT',
  thanyapatp: 'MS.THANYAPHAT PHUMUEANG',
  theerathasp: 'MR.THEERATHAS PAKDEEPAK',
  thomasm: 'MR. THOMAS MOENKEMEIER',
  thongchait: 'MR. THONGCHAI TIWASIRIKUL',
  thongchomphunutr: 'MS. THONGCHOMPHUNUT ROJVIBOONCHAI',
  thornthepk: 'MR. THORNTHEP KHRAIKHRUAN',
  tirawana: 'MS. TIRAWAN AREERAS',
  tirawutn: 'MR. TIRAWUT NORKHUNTOD',
  torritb: 'MR. TORRIT BOONYAKIAT',
  tylerb: 'MR. TYLER BROWN ',
  uraveet: 'MS. URAVEE THEPWIMOLPETCHKUL',
  vaayuk: 'MR. VAAYU KHATTRI',
  vunqt: 'MS. VU NGUYEN QUYNH TRAM',
  wacharapongs: 'RADM. WACHARAPONG SASITHORN',
  wannarats: 'MS.WANNARAT SOMBATPINYO',
  wannatouchp: 'MR. WANNATOUCH PRASERT',
  watcharapols: 'MR.WATCHARAPOL SUPAJAKWATTANA',
  watcharapongb: 'LT. WATCHARAPONG BUMRUNGKLANG',
  wichaic: 'MR.WICHAI CHEEVAPITAKPHOL',
  winyuc: 'MR. WINYU CHAIYAWAN',
  wissarutm: 'MR.WISSARUT MAHARAKKHAKA',
  wisutl: 'MR.WISUT LEKSOMBOON',
  witchayapongp: 'MR.WITCHAYAPONG  PIYATHANYANON',
  wiyadaj: 'MS. WIYADA JONRAKSA',
  worapopk: 'MR. WORAPOP KERDTONGSOOK',
  worapotb: 'MR.WORAPOT BENJANART',
  wyonab: 'MS. WYONA BROWN',
  xinrongw: 'MS. XINRONG WU',
  yanint: 'MS. YANIN TAIYANON',
  yaranyapohnk: 'MS. VARANYAPOHN KASSANUKA',
  yihaow: 'MR. YIHAO WANG',
  yothsayaw: 'MS. YOTHSAYA WATTANAPORN',
  yuthanas: 'MR. YUTHANA SANGMUANG',
  zaidena: 'MR. ZAIDEN ANDERSSON',
  zarawink: 'MR. ZARAWIN KANCHANAPORN',
};

export default qrCardNames;
